module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "pop-header"
  }, [_c('span', [_vm._v("与本人关系：" + _vm._s(_vm.selectContactName))]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.pickerSureBtnClick
    }
  }, [_vm._v("完成")])]), _vm._v(" "), _c('picker', {
    attrs: {
      "data": _vm.innerContactList
    },
    on: {
      "on-change": _vm.change
    },
    model: {
      value: (_vm.selectContact),
      callback: function($$v) {
        _vm.selectContact = $$v
      },
      expression: "selectContact"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aaa18fae!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/common/xy-contact-picker.vue
// module id = 413
// module chunks = 36